import TagManager from 'react-gtm-module';

export const createBidRequestEvent = value => {
  TagManager.dataLayer({ dataLayer: { event: 'bid-request-create', bidRequestValue: value } });
};

export const createStartBidRequestEvent = () => {
  TagManager.dataLayer({ dataLayer: { event: 'bid-request-start' } });
};

export const initialize = args => TagManager.initialize(args);
export const pushEvent = args => TagManager.dataLayer({ dataLayer: { ...args } });



// WEBPACK FOOTER //
// ./src/utils/gtmHelper.js